import { createSelector } from '@reduxjs/toolkit';

import { useReduxSelector } from '../../../hooks';
import { type TViewMode } from '../slice';

import { listingLayoutSelector } from './root';

export const listingLayoutViewModeSelector = createSelector(listingLayoutSelector, state => state.viewMode);

// Пока оставил для обратной совместимости, но в будущем можно будет удалить
export const listingLayoutIsNarrowSelector = createSelector(
  listingLayoutViewModeSelector,
  viewMode => viewMode === 'hybrid' || viewMode === 'map',
);
export function useListingLayoutIsNarrowSelector(): boolean {
  return useReduxSelector(listingLayoutIsNarrowSelector);
}

export function useListingLayoutViewModeSelector(): TViewMode {
  return useReduxSelector(listingLayoutViewModeSelector);
}

export const listingLayoutFiltersHeightSelector = createSelector(listingLayoutSelector, state => state.filtersHeight);

export function useListingLayoutFiltersHeightSelector(): number {
  return useReduxSelector(listingLayoutFiltersHeightSelector);
}
